import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Services
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  // Objetos Observable y Emiters
  private openCardAddressSubjet$ = new Subject<any>();
  private openCardCouponSubjet$ = new Subject<any>();
  private getResummeorderSubjet$ = new Subject<any>();

  constructor(
    private _httpService: HttpService
  ) { }

  openCardCouponEmmiter( data: any ): void {
    this.openCardCouponSubjet$.next(data);
  }

  getSubjetOpenCardCoupon(): Subject<any> {
    return this.openCardCouponSubjet$;
  }

  openCardAddressEmmiter( data: any ): void {
    this.openCardAddressSubjet$.next(data);
  }

  getSubjetOpenCardAddress(): Subject<any> {
    return this.openCardAddressSubjet$;
  }

  getResumeOrderEmmiter( data: any ): void {
    this.getResummeorderSubjet$.next(data);
  }

  getSubjetResumeOrder(): Subject<any> {
    return this.getResummeorderSubjet$;
  }

  // Metodos HTTP

  getResumeOrder(){
    let clientId = localStorage.getItem('clientId');
    let companyId = localStorage.getItem('companyId');
    let headers = {
      'dataResumen': 'true',
      'dataOpciones': 'true',
      'dataUsuario': 'true',
      'dataReserva': 'true',
      'modality': localStorage.getItem('modality'),
      'clientId': clientId,
      'companyId': companyId
    }
    return this._httpService.httpGet(`compras/compra/actual`, headers);
  }
  
  updateAddress(data: any) {
    let clientId = localStorage.getItem('clientId');
    let headers = {
      'clientId': clientId
    }
    return this._httpService.httpPatch(`compras/compra/actual`, data, headers);
  }
  
  createOrder(data: any) {
    let clientId = localStorage.getItem('clientId');
    let headers = {
      'clientId': clientId,
      'modality': localStorage.getItem('modality')
    }
    return this._httpService.httpPut(`compras/compra/checkout`, data, headers);
  }
  
  redeemCoupon(data: any) {
    let clientId = localStorage.getItem('clientId');
    let headers = {
      'clientId': clientId
    }
    data.client_id = clientId
    return this._httpService.httpPost(`cupones/redimir`, data, headers);
  }

  getUrlPayment() {
    let clientId = localStorage.getItem('clientId');
    let headers = {
      'clientId': clientId
    }
    let data = {}
    return this._httpService.httpPut(`compras/compra/pago`, data, headers);
  }

}
